import { date } from 'quasar'

class CalendarEvent {
  constructor (_event) {
    if (_event !== undefined) {
      const assignedTo = _event.assigned_to ? _event.assigned_to : null
      const icon = _event.event_type === 2 ? 'outWork' : 'event'
      const evenType = _event.event_type === 2 ? 'outWork' : 'binnacle_event'
      this.attributes = {
        id: _event.id ? _event.id : null,
        add_to_sprint: _event.add_to_sprint ? _event.add_to_sprint : 0,
        title: _event.form ? _event.form.name : _event.summary ? _event.summary : null,
        summary: _event.form ? _event.location ? _event.location.name : null : _event.description ? _event.description : null,
        location: _event.location ? _event.location : null,
        description: _event.description ? _event.description : null,
        type: _event.form_id ? 'occurrence' : 'binnacle_event',
        type_name: 'Evento',
        start: {
          date: _event.start_date ? _event.start_date.slice(0, 10) : null
        },
        end: {
          date: _event.end_date ? _event.end_date.slice(0, 10) : null
        },
        end_date: _event.end_date ? _event.end_date : null,
        start_date: _event.start_date ? _event.start_date : null,
        time: _event.start_date ? _event.start_date.slice(11) !== '00:00:00' ? _event.start_date.slice(11) : null : null,
        duration: _event.start_date && _event.end_date && _event.start_date.slice(0, 10) === _event.end_date.slice(0, 10) ? date.getDateDiff(_event.end_date.replace(/-/g, '/'), _event.start_date.replace(/-/g, '/'), 'minutes') : null,
        days: _event.start_date && _event.end_date && _event.start_date.slice(0, 10) !== _event.end_date.slice(0, 10) ? date.getDateDiff(_event.end_date.replace(/-/g, '/'), _event.start_date.replace(/-/g, '/'), 'days') : null,
        recurrent: _event.recurrent ? _event.recurrent : 0,
        timezone: _event.timezone ? _event.timezone : null,
        assignment_type: _event.assignment_type ? _event.assignment_type : 4,
        assignments: _event.assignments ? _event.assignments : [],
        created_by: _event.created_by ? Number(_event.created_by) : null,
        assigned_to: _event.assigned_to ? Number(_event.assigned_to) : null,
        organization_id: _event.organization_id ? _event.organization_id : null,
        status: _event.status ? 1 : 0,
        event_type: _event.form_id ? 'occurrence' : evenType,
        icon: _event.form ? 'form' : icon,
        form: _event.form ? _event.form : null,
        event_id: _event.routine_event_id ? _event.routine_event_id : null,
        routine: _event.routine ? _event.routine : null,
        occurrence_id: _event.occurrence_id ? _event.occurrence_id : null,
        score: _event.score ? _event.score : null,
        group_id: _event.group_id ? _event.group_id : null,
        form_assignment_role_id: _event.form_assignment_role_id ? _event.form_assignment_role_id : null,
        recurrence_id: _event.recurrence_id ? _event.recurrence_id : null,
        occurrence: _event.occurrence ? _event.occurrence : null,
        meetingLink: _event.meeting_link ? _event.meeting_link : null,
        hyperlink: _event.hyperlink ? _event.hyperlink : null,
        fileId: _event.file_id ? _event.file_id : null,
        file: _event.file ? _event.file : null,
        roleId: _event.role ? _event.role.role_id : null,
        triggeredBy: _event.user_guest_id ? _event.user_guest_id : assignedTo,
        assignedUser: _event.assigned_user ? _event.assigned_user : null,
        guests: _event.guests ? _event.guests : [],
        enforce_deadline: _event.enforce_deadline ? _event.enforce_deadline : 0
      }

      if (!_event.date) {
        this.attributes.start_date = date.formatDate(new Date(_event.start_date.replace(/-/g, '/')), 'YYYY-MM-DD HH:mm:ss')
        this.attributes.end_date = date.formatDate(new Date(_event.end_date.replace(/-/g, '/')), 'YYYY-MM-DD HH:mm:ss')
      }
    }
  }
}

export default CalendarEvent
